import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import dayjs from 'dayjs';
import locales from './utils/locales/';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
import Input from './Input';
import Calendar from './Calendar';
export default function DatePicker({ value, displayFormat, locale = 'ru', open = false, onSelect, onBlur, t, className = '' }) {
    const tr = t !== null && t !== void 0 ? t : (v => v);
    const [operationValue, setOperationValue] = React.useState(value);
    const [showCalendar, setShowCalendar] = React.useState(false);
    const [currentLocale, setCurrentLocale] = React.useState();
    React.useEffect(() => {
        locales[locale]().then(() => {
            dayjs.locale(locale);
            setCurrentLocale(locale);
        }).catch((err) => {
            console.log('failed loading locale! Used defaults. -', err);
        });
    }, [locale]);
    React.useEffect(() => { setShowCalendar(open); }, [open]);
    const displayValue = React.useMemo(() => {
        if (!currentLocale) {
            return '';
        }
        return dayjs(operationValue).format(displayFormat);
    }, [currentLocale, value, operationValue, displayFormat]);
    const onDateSelect = (date) => {
        setOperationValue(date);
        setShowCalendar(false);
        onSelect(dayjs.utc(date).toISOString());
        console.log('selected date - ', dayjs.utc(date).toISOString());
    };
    return (_jsxs(Container, { className: `${className} ui-datepicker`, children: [_jsx(Input, { value: displayValue, onFocus: () => setShowCalendar(true) }), showCalendar &&
                _jsx(CalendarContainer, { children: _jsx(StyledCalendar, { value: new Date(operationValue), isMonthsSelector: true, isShowToday: true, onDateSelect: onDateSelect, t: tr }) })] }));
}
;
const Container = styled.div `
  position: relative;
`;
const CalendarContainer = styled.div `
  position: relative;
`;
const StyledCalendar = styled(Calendar) `
  border-radius: 0.25rem;
  margin-top: 0.25rem;
`;
